.section {
  padding-block: clamp(48px, 7vw, 80px);
  background: var(--bg-alt);
}

.head {
  max-width: 56ch;
  margin-bottom: clamp(28px, 4vw, 40px);
}
.head h2 {
  margin-top: 10px;
  font-size: var(--step-3);
  text-transform: uppercase;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: var(--border-subtle);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  overflow: hidden;
}
@media (max-width: 700px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.card {
  background: var(--bg-surface);
  padding: 22px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon {
  width: 24px;
  height: 24px;
  flex: none;
  color: var(--action);
}

.card span {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-primary);
}
